// ----------------------------------------------------------------------

function path(root, sublink) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '';
const ROOTS_DASHBOARD = '';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    register: path(ROOTS_AUTH, '/register'),
    loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
    registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
    verify: path(ROOTS_AUTH, '/verify'),
    confirm: path(ROOTS_AUTH, '/confirm'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
    comingSoon: '/coming-soon',
    maintenance: '/maintenance',
    pricing: '/pricing',
    payment: '/payment',
    about: '/about-us',
    contact: '/contact-us',
    faqs: '/faqs',
    page403: '/403',
    page404: '/404',
    page500: '/500',
    components: '/components',
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    plugins: {
        all: path(ROOTS_DASHBOARD, '/plugins'),
    },
    products: {
        all: path(ROOTS_DASHBOARD, '/products'),
        add: path(ROOTS_DASHBOARD, '/products/add'),
        edit: path(ROOTS_DASHBOARD, '/products/:id'),
        delete: path(ROOTS_DASHBOARD, '/products/:id/delete'),
        versions: path(ROOTS_DASHBOARD, '/products/:id/versions'),
        release: path(ROOTS_DASHBOARD, '/products/:id/release/:versionId'),
        groups: path(ROOTS_DASHBOARD, '/product-groups'),
        editor: path(ROOTS_DASHBOARD, '/products/:id/editor')
    },
    groups: {
        all: path(ROOTS_DASHBOARD, '/product-groups'),
        single: path(ROOTS_DASHBOARD, '/product-groups/:id'),
        edit: path(ROOTS_DASHBOARD, '/product-groups/:id'),
        editor: path(ROOTS_DASHBOARD, '/product-groups/:id/editor')
    },
    general: {
        app: path(ROOTS_DASHBOARD, '/app'),
        ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
        analytics: path(ROOTS_DASHBOARD, '/analytics'),
        banking: path(ROOTS_DASHBOARD, '/banking'),
        booking: path(ROOTS_DASHBOARD, '/booking'),
    },
    mail: {
        root: path(ROOTS_DASHBOARD, '/mail'),
        all: path(ROOTS_DASHBOARD, '/mail/all'),
    },
    chat: {
        root: path(ROOTS_DASHBOARD, '/chat'),
        new: path(ROOTS_DASHBOARD, '/chat/new'),
        view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
    },
    calendar: path(ROOTS_DASHBOARD, '/calendar'),
    kanban: path(ROOTS_DASHBOARD, '/kanban'),
    permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
    buyer: {
        root: path(ROOTS_DASHBOARD, '/buyer'),
        all: path(ROOTS_DASHBOARD, '/buyers/all')
    },
    licenses: {
        single: path(ROOTS_DASHBOARD, '/licenses/:id'),
        license: path(ROOTS_DASHBOARD, '/licenses/:id'),
        all: path(ROOTS_DASHBOARD, '/licenses')
    },
    orders: {
        all: path(ROOTS_DASHBOARD, '/orders'),
        order: path(ROOTS_DASHBOARD, '/orders/:id')
    },
    subscriptions: {
        all: path(ROOTS_DASHBOARD, '/subscriptions'),
        subscription: path(ROOTS_DASHBOARD, '/subscriptions/:id')
    },
    coupons: {
        all: path(ROOTS_DASHBOARD, '/coupons'),
        single: path(ROOTS_DASHBOARD, '/coupons/:id'),
    },
    user: {
        root: path(ROOTS_DASHBOARD, '/user'),
        new: path(ROOTS_DASHBOARD, '/user/new'),
        list: path(ROOTS_DASHBOARD, '/user/list'),
        cards: path(ROOTS_DASHBOARD, '/user/cards'),
        profile: path(ROOTS_DASHBOARD, '/user/profile'),
        account: path(ROOTS_DASHBOARD, '/user/account'),
        edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
        demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    },
    account: {
        general: path(ROOTS_DASHBOARD, '/account/general'),
        security: path(ROOTS_DASHBOARD, '/account/security')
    },
    eCommerce: {
        root: path(ROOTS_DASHBOARD, '/e-commerce'),
        shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
        list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
        checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
        new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
        view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
        edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
        demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
        demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    },
    invoice: {
        root: path(ROOTS_DASHBOARD, '/invoice'),
        list: path(ROOTS_DASHBOARD, '/invoice/list'),
        new: path(ROOTS_DASHBOARD, '/invoice/new'),
        view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
        edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
        demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
        demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
    },
    blog: {
        root: path(ROOTS_DASHBOARD, '/blog'),
        posts: path(ROOTS_DASHBOARD, '/blog/posts'),
        new: path(ROOTS_DASHBOARD, '/blog/new'),
        view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
        demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
